import { ThemeResponseDto } from '../dto/response/theme-response.dto';
import { ThemeSaveRequestDto } from '../dto/request/theme-save-request.dto';
import { ThemeUpdateRequestDto } from '../dto/request/theme-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class ThemeService extends BaseLandscapeService {
  public async fetchThemes(): Promise<ThemeResponseDto[]> {
    const response = await this.get<ThemeResponseDto[]>(`/theme`);
    return response.data;
  }

  public async fetchThemeById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<ThemeResponseDto> {
    const response = await this.get<ThemeResponseDto>(`/theme/${id}`, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async saveTheme(
    saveRequest: ThemeSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<ThemeResponseDto> {
    const response = await this.post<ThemeResponseDto>(`/theme`, saveRequest, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async updateTheme(
    updateRequest: ThemeUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<ThemeResponseDto> {
    const response = await this.put<ThemeResponseDto>(`/theme`, updateRequest, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async deleteTheme(existingId: string): Promise<void> {
    await this.delete<void>(`/theme/${existingId}`);
  }
}

const themeService = new ThemeService();
export default themeService;
